export default {"src":"/_next/static/media/icon-add.ddc62311.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};